
import Alert from 'react-bootstrap/Alert';


export const AlertMessage = ({ show, variant, header, message, onClose }) => 
{
    if (!show) { return <></> }

    return (
        <Alert className="mx-auto w-50" variant={variant} onClose={onClose} dismissible>
            {header && <Alert.Heading>{header}</Alert.Heading>}
            <p>{message}</p>
        </Alert>
    )
}
